export enum VictaCreditTypeEnum {
  PCP = 1,
  CREDIT_CARD = 2,
  STORE_CARD = 3,
  CATALOGUE = 4,
  LOAN = 5,
  CATALOGUE_AND_STORE_CARD = 6,
}
